import { z } from "zod";

export const EditProdutoSchema = z.object({
    nome: z.string()
        .nonempty("O nome do produto é obrigatório.")
        .min(3, "O nome do produto deve ter no mínimo 3 caracteres")
        .max(120, "O nome do produto deve ter no máximo 120 caracteres"),

    valor: z.string()
        .nonempty("O valor do produto é obrigatório.")
        .refine((v) => v !== "R$ 0:00", {
            message: "O valor do produto não pode ser vazio ou zero.",
        }),

    status: z.enum(["S", "N"], {
        errorMap: () => ({ message: "O status deve ser 'S' ou 'N'" })
    })
});
